import { GET, POST, PUT } from './core';

const getEndpointWithPrefix = (endpoint) => `/rbac${endpoint}`;

// all available permissions
export const getAllPermissions = (token) => {
  return GET(getEndpointWithPrefix('/permissions'), token);
};

// roles with their permissions
export const getRolesWithPermissions = (token) => {
  return GET(getEndpointWithPrefix('/roles'), token);
};

// Update permission
export const updateRolePermissions = (token, role, permissions) => {
  return PUT(
    getEndpointWithPrefix('/roles/permissions/sync'),
    { role, permissions },
    token
  );
};

// create a new role.
export const createRole = (token, name, description) => {
  return POST(getEndpointWithPrefix('/roles/create'), { name, description }, token);
};

// GET all roles
export const getRolesList = (token) => {
  return GET(getEndpointWithPrefix('/roles/list'), token);
};


